import { render } from "./OrderWarehouseDetail.vue?vue&type=template&id=40c0ca7a&scoped=true&ts=true"
import script from "./OrderWarehouseDetail.vue?vue&type=script&lang=ts"
export * from "./OrderWarehouseDetail.vue?vue&type=script&lang=ts"

import "./OrderWarehouseDetail.vue?vue&type=style&index=0&id=40c0ca7a&scoped=true&lang=css"
import "./OrderWarehouseDetail.vue?vue&type=style&index=1&id=40c0ca7a&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c0ca7a"]])

export default __exports__